module.exports = "https://www.gc-pro.gnp.com.mx/7b299d7da5d2d5e02f286127b3359b5f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/load_mini.gif
// module id = 156
// module chunks = 0